// Shared validation patterns + input masks, to avoid per-form drift.
export const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const PHONE_MASK = '(999) 999-9999';
export const PHONE_PATTERN = /^\(\d{3}\) \d{3}-\d{4}$/;
export const ZIP_CODE_PATTERN = /^\d{5}$/;
/** Person and family names: letters, spaces, apostrophes and hyphens — never
 *  digits. Doubles as the `pKeyFilter` so digits can't be typed either. */
export const NAME_PATTERN = /^[A-Za-z\s'-]+$/;

/** The date-of-birth window every portal accepts for an exhibitor or family
 *  member: September 1, 2007 through August 31, 2018. Module-level constants so
 *  the datepicker keeps a stable `minDate`/`maxDate` reference — handing it a
 *  freshly built Date on each change-detection pass rebuilds the view and
 *  strands the year arrows on the current decade. */
export const MIN_BIRTH_DATE = new Date(2007, 8, 1);
export const MAX_BIRTH_DATE = new Date(2018, 7, 31);
export const BIRTH_DATE_RANGE_LABEL = 'Eligible birth dates: September 1, 2007 - August 31, 2018';
export const UNAVAILABLE_VALUE = 'N/A';

/** Middle name is required everywhere, so it also has to accept the literal
 *  "N/A" — i.e. the slash the other name fields reject. */
export const MIDDLE_NAME_PATTERN = /^[A-Za-z\s'\-/]+$/;
export const MIDDLE_NAME_HELP_LABEL = `Enter "${UNAVAILABLE_VALUE}" if no middle name is applicable.`;

/** Shown under a 4-H club / FFA chapter dropdown that has entries filed under it. */
export const ENTRY_CLUB_LOCK_MESSAGE = 'You cannot edit this club as it is tied to an entry.';
export const ENTRY_CHAPTER_LOCK_MESSAGE = 'You cannot edit this chapter as it is tied to an entry.';

/** Admin confirm for changing a 4-H club and/or FFA chapter that has entries. */
export function entryClubChangeConfirm(
  noun: string,
  club: boolean,
  chapter: boolean
): { title: string; message: string } {
  const both = club && chapter;
  let title = 'Confirm Chapter Change';
  let what = 'FFA chapter';
  if (both) {
    title = 'Confirm Club and Chapter Change';
    what = '4-H club and FFA chapter';
  } else if (club) {
    title = 'Confirm Club Change';
    what = '4-H club';
  }
  return {
    title,
    message: `This ${noun} has entries filed under this ${what}. Changing ${both ? 'them' : 'it'} may affect existing entries. Do you want to continue?`
  };
}
